module.exports = __webpack_public_path__ + "static/media/lognew2.0778c1f8.png";